import { User } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';

interface UserProfile {
  name?: string;
  email: string;
  createdAt: Date;
  updatedAt: Date;
  subscription: 'free' | 'pro' | 'business' | 'enterprise';
  settings: {
    notifications: boolean;
    theme: 'light' | 'dark';
  };
}

export async function createUserProfile(user: User, additionalData: Partial<UserProfile> = {}): Promise<void> {
  if (!user) throw new Error('No user provided to createUserProfile');

  const userRef = doc(db, 'users', user.uid);
  const { email, displayName } = user;
  const createdAt = new Date();

  const userData: UserProfile = {
    email: email || '',
    name: displayName || additionalData.name || 'Anonymous',
    createdAt,
    updatedAt: createdAt,
    subscription: 'free',
    settings: {
      notifications: true,
      theme: 'light'
    },
    ...additionalData
  };

  await setDoc(userRef, userData);
}